import { SubmittalFormValues } from './SubmittalForm'

/** The slice of SubmittalDetailFragment the copy dialog reads. */
export interface SubmittalCopySource {
  id: string
  displayNumber: string
  title: string
  description?: string | null
  companyName?: string | null
  dueDate?: string | null
  responsible?: { id: string } | null
  specSection?: { id: string } | null
  category?: { id: string } | null
  subcategory?: { id: string } | null
  discipline?: { id: string } | null
  package?: { id: string } | null
}

/**
 * Form values for "Copy to new": every editable field of the source, verbatim,
 * with the number left blank so the server assigns the next one unless the user
 * types their own. Status, revisions, attachments and reviews are never copied —
 * the copy is a fresh DRAFT.
 */
export const copyInitialValues = (source: SubmittalCopySource): SubmittalFormValues => ({
  displayNumber: '',
  title: source.title || '',
  description: source.description || '',
  companyName: source.companyName || '',
  responsibleId: source.responsible?.id || '',
  dueDate: source.dueDate || null,
  specSectionId: source.specSection?.id || '',
  categoryId: source.category?.id || '',
  subcategoryId: source.subcategory?.id || '',
  disciplineId: source.discipline?.id || '',
  packageId: source.package?.id || '',
})
